import { Box, Typography } from "@mui/material";
import { TableWrapper } from "../../../../TableStyle";
import NoRecordsFound from "../../../UiComponents/NoRecordsFound/NoRecordsFound";
import React from "react";
import styled from "styled-components";

import LogStatusBadge from "../../../UiComponents/LogStatusBadge/LogStatusBadge";
interface LogsTableInterface {
  data: any;
  headers: any;
  notificationStatus?: boolean;
  type?: string;
}

const LogsTable = ({ headers, data, notificationStatus, type }: LogsTableInterface) => {
  // Default mapping for WhatsApp logs (backward compatibility)
  const whatsappKeyToHeaderMap: any = {
    "Sent On": "sent_on",
    "Mobile Number": "mobile",
    "Sent Status": "sent_status",
    Delivered: "delivered",
    Read: "read",
    Failed: "failed",
    Replied: "replied",
    Amount: "amount",
    "Amount Details": "amount_details",
    Refunded: "refunded",
    Source: "source",
    "Reverted Amount":" reverted_amount",
    Template: "template_name",
    "Template Category": "template_category",
    "Retried": "retried",
  };
  const colWidth: any = {
    "Sent On": 250,
    "Mobile Number": 200,
    "Sent Status": 200,
    Delivered: 150,
    Read: 150,
    Failed: 150,
    Replied: 150,
    Amount: 150,
    "Amount Details": 300,
    Refunded: 150,
    Source: 150,
    "Reverted Amount": 200,
    Template: 200,
    "Template Category": 200,
    Date: 220,
    Action: 300,
    Module: 200,
    Category: 150,
    "Input Tokens": 150,
    "Output Tokens": 150,
    "Credits Used": 150,
    "Tokens Used": 180,
    Description: 520,
    "User ID": 200,
    Cost: 200,
    "Retried": 150,
  };

  const getCellValue = (row: any, header: any) => {
    if (type === "ai_whatsapp_template" || type === "ai_inbox_chat" || type === "smart_ai" || type === "conversation") {
      console.log("🔍 Getting cell value for:", header.key, "Value:", row[header.key]);
      return row[header.key];
    }
    return row[whatsappKeyToHeaderMap[header?.label]];
  };

  return (
    <TableWrapper height={`calc(100vh - ${notificationStatus ? "354px" : "310px"})`} style={{ height: "calc(100vh - 300px)" }}>
      <Box sx={{ overflowX: "auto" }}>
        <div>
          <Box className="table-header">
            {/* Table Header */}
            <Box className="table-row" style={{ padding: 0 }}>
              {headers?.map((header: any, index: number) => {
                const isSentStatus = header?.key === "sent_status";
                return (
                  <Box
                    key={index}
                    className={`col-head ${header?.key?.toLowerCase().replaceAll(" ", "_")}`}
                    style={{
                      minWidth: colWidth[header?.label] + "px",
                      paddingLeft: isSentStatus ? "35px" : "",
                    }}
                    justifyContent={header === "Actions" ? "flex-end" : ""}
                  >
                    <Typography sx={{ fontWeight: 500 }}>
                      {header?.label}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
          <Box className="table-body">
            {data && data?.length === 0 ? (
              <NoRecordsFound height="calc(100vh - 279px)" />
            ) : (
              <React.Fragment>
                {data &&
                  data?.map((row: any, rowIndex: any) => {
                    return (
                      <Box key={rowIndex} className={`table-row`}>
                        {headers?.map((header: any, ColumnIndex: any) => {
                          const cellValue = getCellValue(row, header);
                          return (
                            <Box
                              key={ColumnIndex}
                              className={`col-body ${header?.key?.toLowerCase().replaceAll(" ", "_")}`}
                              title={cellValue?.toString()}
                              style={{
                                minWidth: colWidth[header?.label] + "px",
                                color: "black",
                              }}
                            >
                              <TextWrapper>
                                <Typography className="text-area">
                                  {header.key === "sent_status" ? (
                                    <>
                                      {cellValue !== "Successful" ? (
                                        <LogStatusBadge
                                          status="Error_log"
                                          message={cellValue}
                                        />
                                      ) : (
                                        <LogStatusBadge
                                          status="Successful_log"
                                          message={cellValue}
                                        />
                                      )}
                                    </>
                                  ) : (
                                    cellValue !== null && cellValue !== undefined
                                      ? cellValue
                                      : "--"
                                  )}
                                </Typography>
                              </TextWrapper>
                            </Box>
                          );
                        })}
                      </Box>
                    );
                  })}
              </React.Fragment>
            )}
          </Box>
        </div>
      </Box>
    </TableWrapper>
  );
};
export default LogsTable;

export const TextWrapper = styled.div`
  & {
    width: 100%;
    display: flex;
    align-items: center;
    .text-area {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
